import { render } from "./YearPage.vue?vue&type=template&id=5fd1ebd6&scoped=true"
import script from "./YearPage.vue?vue&type=script&lang=js"
export * from "./YearPage.vue?vue&type=script&lang=js"

import "./YearPage.vue?vue&type=style&index=0&id=5fd1ebd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd1ebd6"]])

export default __exports__